import React from "react";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "60vh",
};

const center = {
  lat: -33.827539808297786,
  lng: 151.2029868529043,
};

function MyComponent() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB0zCLzlOty8hQNlUtm-M2isJb0V2LmLgA",
  });

  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17}>
      <MarkerF position={center}>
        <InfoWindowF position={center}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontWeight: "bold" }}>
              Shop 1, 40 Falcon Street Crow Nest, NSW 2065, Australia
            </div>
            <div>
              <a href="https://maps.app.goo.gl/cjrgRNvdST2M9UpN9">Directions</a>
            </div>
          </div>
        </InfoWindowF>
      </MarkerF>
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(MyComponent);
